import { useEffect, type ReactElement } from 'react';
import { useSearchParams } from 'react-router-dom';
import { ReceiptSheet } from './ReceiptSheet';
import { useReceiptStore } from '@/shared/stores/receipt.store';

/**
 * The one receipt sheet of the app (Task 1.3), in the layout: opened from
 * any screen through `useReceiptStore`, or by a `?receipt=<postId>` link
 * (the `post_published` notification), which is taken off the address when
 * the sheet closes.
 */
export function ReceiptHost(): ReactElement {
  const [params, setParams] = useSearchParams();
  const postId = useReceiptStore((s) => s.postId);
  const open = useReceiptStore((s) => s.open);
  const close = useReceiptStore((s) => s.close);
  const fromLink = params.get('receipt');

  useEffect(() => {
    if (fromLink) open(fromLink);
  }, [fromLink, open]);

  const onClose = (): void => {
    close();
    if (params.has('receipt')) {
      const next = new URLSearchParams(params);
      next.delete('receipt');
      setParams(next, { replace: true });
    }
  };

  return <ReceiptSheet postId={postId} onClose={onClose} />;
}
